import React, { useContext, useRef, useEffect } from 'react';
import { SubscriptionContext } from '..';

interface IntersectionSubscriberProps {
  tagName: string;
  children?: any;
  dataHook?: string;
  className: string;
  id: string;
}

export const IntersectionSubscriber = ({
  tagName = 'section',
  children,
  dataHook,
  ...props
}: IntersectionSubscriberProps) => {
  const {
    subscribeToIntersectionObserver,
    unsubscribeFromObserver,
  } = useContext(SubscriptionContext);

  const wrapperRef = useRef(null);

  useEffect(() => {
    return () =>
      wrapperRef.current && unsubscribeFromObserver(wrapperRef.current);
  }, []);

  const handleRef = (currentRef) => {
    subscribeToIntersectionObserver &&
      subscribeToIntersectionObserver(currentRef);
    wrapperRef.current = currentRef;
  };

  return React.createElement(tagName, {
    ...props,
    ref: handleRef,
    'data-hook': dataHook,
    children,
  });
};
